"use strict";
/*
 * Role based. We currently have three roles:
 *
 *   Role      | Operation                   | Scope
 *  ___________|_____________________________|___________________________
 *   endUser   |  can read content           |  Content leaf (program)
 *   editor    |  can write/publish content  |  Department
 *   admin     |  can everything             |  Organization
 *
 * endUser has resourceIds -
 *
 *
 * Root
 *  |
 *  +---. Region Midt (Organization)
 *      |
 *      +---. Skejby Sygehys (Organization)
 *      |   |
 *      |   +---. Department (Department)
 *      |       |
 *      |       +---. Mama (Content)
 *      |
 *      |
 *      +---. Skive Hospital (Organization)
 *          |
 *          +---. Department (Department)
 *              |
 *              +---. Skulder (Content)
 *              |
 *              +---. Hofte (Content)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCorrectCMSUserType = exports.getShareProgramUserExpiration = void 0;
function getShareProgramUserExpiration(userType) {
    return userType === 'ViewerLicense' ? '3' : '30';
}
exports.getShareProgramUserExpiration = getShareProgramUserExpiration;
function isCorrectCMSUserType(str) {
    switch (str) {
        case 'SuperAdmin':
        case 'Admin':
        case 'Editor':
        case 'Translator':
        case 'EmbedIntegration':
        case 'ViewerLicense':
            return true;
        default:
            return false;
    }
}
exports.isCorrectCMSUserType = isCorrectCMSUserType;
//# sourceMappingURL=user.js.map